import React from 'react';
import { Layout, Dropdown, Avatar, Space, Typography, message, Tag } from 'antd';
import { UserOutlined, LogoutOutlined, SettingOutlined, BellOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useUser } from '../../contexts/UserContext';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader: React.FC = () => {
    const { user, logout } = useUser();

    const getRoleColor = (role: string): string => {
        switch (role) {
            case 'admin': return 'red';
            case 'dashboard-viewer': return 'blue';
            case 'station-admin': return 'green';
            default: return 'default';
        }
    };

    const getRoleText = (role: string): string => {
        switch (role) {
            case 'admin': return '系统管理员';
            case 'dashboard-viewer': return '数据大屏';
            case 'station-admin': return '站点管理员';
            default: return role;
        }
    };

    const userMenuItems: MenuProps['items'] = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: '个人资料',
        },
        {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '系统设置',
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: '退出登录',
            danger: true,
        },
    ];

    const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
        if (key === 'logout') {
            logout();
            message.success('已成功退出登录');
        } else if (key === 'profile') {
            message.info('个人资料功能开发中...');
        } else if (key === 'settings') {
            message.info('系统设置功能开发中...');
        }
    };

    return (
        <Header style={{
            background: '#fff',
            padding: '0 24px',
            boxShadow: '0 1px 4px rgba(0,21,41,.08)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            <div>
                <Text strong style={{ fontSize: '16px' }}>
                    功率预测管理系统
                </Text>
            </div>

            <Space size="middle">
                <BellOutlined style={{ fontSize: '18px', cursor: 'pointer' }} />
                <Dropdown menu={{ items: userMenuItems, onClick: handleMenuClick }} placement="bottomRight">
                    <Space style={{ cursor: 'pointer' }}>
                        <Avatar
                            icon={<UserOutlined />}
                            style={{ backgroundColor: user ? getRoleColor(user.role) : '#1890ff' }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Text style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                {user?.name || '未知用户'}
                            </Text>
                            {user && (
                                <Tag
                                    color={getRoleColor(user.role)}
                                    style={{ fontSize: '10px', lineHeight: '16px', margin: 0 }}
                                >
                                    {getRoleText(user.role)}
                                </Tag>
                            )}
                        </div>
                    </Space>
                </Dropdown>
            </Space>
        </Header>
    );
};

export default AppHeader; 